<div class="return-part-content-area ws-flex-container-vertical ws-stretch">

    @if (!showOutput) {
        <div class="ws-section ws-flex-container-vertical ws-flex-auto">
            <span class="return-generation-info">Packages are available once preparation is complete</span>
        </div>
    }

    @if (showOutput) {
        <div class="ws-section ws-flex-container-vertical ws-flex-auto">
            <return-output-package-list></return-output-package-list>
        </div>
    }

    @if (showOutput) {
        <div class="ws-section ws-flex-none ws-flex-container-vertical">
            <return-output-printing-mailing></return-output-printing-mailing>
        </div>
    }

    @if (showOutput) {
        <div class="float-end">
            <button type="button"
                    class="ace-btn btn-sm ace-btn btn-primary"
                    [disabled]="!packagesSelected || !printingOptionsSelected || disableDownload"
                    title="Download Selected Items"
                    (click)="download()">
                Download Selected Items
            </button>
        </div>
    }

</div>
